import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from '../../../theme';
import Flex from '../Flex';
import Link from '../Link';

const BreadcrumbLink = styled(Link)`
  display: inline-block;
  color: ${theme.colors.dark};
  font-size: ${theme.fontSizes.small};
  line-height: 1rem;
  text-decoration: none;
  &:after {
    content: '/';
    padding: 0 2px;
  }
  &:last-child:after {
    content: '';
  }
  &:hover {
    color: ${theme.colors.primary};
    &:after {
      color: ${theme.colors.dark};
    }
  }
`;

const BreadCrumbWrapper = styled(Flex)`
  line-height: 0.9rem;
  flex-wrap: wrap;
`;

const Breadcrumb = ({ paths }) => (
  <BreadCrumbWrapper>
    {paths.map((item) => (
      <BreadcrumbLink
        key={item.path}
        href={item.path}
        to={item.path}
        onClick={(e) => e.stopPropagation()}
      >
        {item.label}
      </BreadcrumbLink>
    ))}
  </BreadCrumbWrapper>
);
Breadcrumb.propTypes = {
  paths: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Breadcrumb;
